import { faFolder } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IPictureFileMetadataResponse } from '@kcftech/prometheustypescriptapiclient';
import { FolderName } from 'pages/Settings/FileLibrary/styled';

export type FolderNameCellProps = Readonly<{
    folderData: IPictureFileMetadataResponse;
    onFolderClick: (folderData: IPictureFileMetadataResponse) => void;
}>;

export function FolderNameCell({ folderData, onFolderClick }: FolderNameCellProps) {
    return (
        <>
            <FontAwesomeIcon icon={faFolder} color="var(--warning-default)" size="3x" />
            <FolderName onClick={() => onFolderClick(folderData)}>
                {folderData.DisplayName}
            </FolderName>
        </>
    );
}
